import { themeVars } from '../theme/vars';
import { space } from '../tokens';
import { typography } from '../typography';
import { style, styleVariants } from '../layer.css';

export const linkButton = style({
  backgroundColor: 'transparent',
  padding: 0,
  width: 'fit-content',
  height: 'fit-content',
  border: 0,
  cursor: 'pointer',
  gap: space.s8,
  display: 'inline-flex',
  alignItems: 'center',
  color: themeVars.link.idle,

  ':hover': {
    textDecoration: 'underline',
  },

  ':disabled': {
    color: themeVars.link.disabled,
    cursor: 'default',
    textDecoration: 'none',
  },
});

export const linkButtonSize = styleVariants({
  small: [
    {
      ...typography['labelSm'],
    },
  ],
  medium: {
    ...typography['labelMd'],
  },
  large: {
    ...typography['labelLg'],
  },
});
